//卖点导航
$('#part_img_1').click(function(){
	$('html,body').animate({scrollTop:$('#part_img_1_link').offset().top - 100}, 0);
});
$('#part_img_2').click(function(){
	$('html,body').animate({scrollTop:$('#part_img_2_link').offset().top - 100}, 0);
});
$('#part_img_3').click(function(){
	$('html,body').animate({scrollTop:$('#part_img_3_link').offset().top - 100}, 0);
});
$('#part_img_4').click(function(){
	$('html,body').animate({scrollTop:$('#part_img_4_link').offset().top - 200}, 0);
});
$('#part_img_5').click(function(){
	$('html,body').animate({scrollTop:$('#part_img_5_link').offset().top - 200}, 0);
});
$('#part_img_6').click(function(){
	$('html,body').animate({scrollTop:$('#part_img_5_link').offset().top - 200}, 0);
});
$('#part_img_7').click(function(){
	$('html,body').animate({scrollTop:$('#part_img_6_link').offset().top -200}, 0);
});

//弟8屏轮播图
var mySwiper_1 = new Swiper("#swiper_1", {
	loop: true,
    slidesPerView: "auto",
    centeredSlides: true,
    speed: 1000,
    disableOnInteraction: false,
    autoplay: {
      delay: 6000,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    on: {
	    slideChange: function () {
	      var activeIndex = this.activeIndex;
	    }
	  }
  });
  // mySwiper_1.autoplay.stop();
  
//弟9屏轮播图
var mySwiper = new Swiper("#swiper_gal", {
	loop: true,
    slidesPerView: "auto",
    spaceBetween: 30,
    centeredSlides: true,
    speed: 4000,
    autoplay: {
      delay: 0,
    },
  });
  
var client_width = $(window).width() + 17;
	setTimeout(function(){
		ut1();
	}, 500);
	
	function ut1(){
		var i = $(window).width(), 
			n = window.innerHeight, 
			r = i <= 1100;
		var isS = $(window).width() <1367 && $(window).width() > 1342;
		
		if (!r) {
			
			//卖点鼠标悬浮放大缩小动效
			$("#ut3 .ut3_3 .bigbox .ul_flex .div_box").hover(function(){
				$(this).find("img").css("transform","scale(1.05)");
			},function(){
				$(this).find("img ").css("transform","scale(1)");
			});
			
			//第二屏动效
			var ut3_2 = $("#ut3 .ut3_2 .bigbox");
			var box_1_img = $("#ut3 .ut3_2 .bigbox .box_1 .div_img");
			var s_2 = gsap.timeline();
				ScrollTrigger.create({
					animation: s_2,
					trigger: box_1_img,
					scrub: !0,
					start: "top 40%",
					end: "bottom 100%",
					onUpdate: function(e) {
						if(e.progress == 1){
							$("#ut3 .ut3_2 .bigbox .box_1").addClass("active");
							setTimeout(function(){
								$("#ut3 .ut3_2 .bigbox .box_left").fadeIn()
							}, 1100);
							
						}
					}
				});
				
			/*第五屏滑块*/
			let img = document.querySelector("#img_cover");
			let btn = document.querySelector("#btn_icon");
			let nav = document.querySelector(".ue12plus_5_2_box");
			let leftBottom = document.querySelector("#leftBottom");
			let rightBottom = document.querySelector("#rightBottom");
			btn.onmousedown = function (e) {
			    let clientx = e.clientX; // 点击获取鼠标初始X坐标
			    nav.onmousemove = function () {
			        let e = arguments[0] || window.event;
			        let X = e.clientX; // 移动时获取鼠标移动时的X坐标
			        let imgW = parseInt(getComputedStyle(img, null).width);
			        img.style.width = `${imgW + X - clientx}px`; // 图片宽度 = 移动时的X坐标 - 点击时的初始坐标 也就是 图片宽度 + 鼠标X坐标的偏移量
			        clientx = X; // 将最新的位置的X坐标 赋值给 点击初始坐标 也就是 更新 X坐标初始值
			    }
			};
			document.onmouseup = function () {
			    nav.onmousemove = null;
			}	
				
			//弟7屏动效
			var ut3_7 = $("#ut3 .ut3_7 .bigbox");
			var div_img_1 = $("#ut3 .ut3_7 .bigbox .div_img_1");
			var div_img_3 = $("#ut3 .ut3_7 .bigbox .div_img_3");
			var div_img_4 = $("#ut3 .ut3_7 .bigbox .div_img_4");
			var ut3_7_sticky = $("#ut3 .ut3_7 .ut3_7_sticky");
			var s_7 = gsap.timeline();
				s_7.to(div_img_1, 0, {
				   top: "0.9vw",
				}).to(div_img_1, 2, {
					top: "2.0vw",
	            });
	            
	            s_7.to(div_img_4, 0, {
				   top: "9.1vw",
				   left: "29.5vw",
				}).to(div_img_4, 3, {
				   top: "18.9vw",
				   left: "47.5vw",
	            });
	            
	            s_7.to(div_img_3, 0, {
				   top: "9.1vw",
				   left: "29.5vw",
				}).to(div_img_3, 3, {
				   top: "14.9vw",
				   left: "19.5vw",
	            });
	            
				ScrollTrigger.create({
					animation: s_7,
					trigger: ut3_7_sticky,
					scrub: !0,
					start: "top 1000%",
					end: "bottom 100%",
					onUpdate: function(e) {
					}
				});
			
			//弟8屏动画
			// var ut3_8_sticky = $("#ut3 .ut3_8 .ut3_8_sticky");
			// var s_8 = gsap.timeline();
			// 	ScrollTrigger.create({
			// 		animation: s_8,
			// 		trigger: ut3_8_sticky,
			// 		scrub: !0,
			// 		start: "top 100%",
			// 		end: "bottom 100%",
			// 		onUpdate: function(e) {
			// 			var progress_8 = e.progress
			// 				console.log(progress_8)
			// 				$("#ut3 .ut3_8 .swiper-slide .div_back").removeClass("active");
			// 				$("#ut3 .ut3_8 .swiper-slide.swiper-slide-active .div_back").removeClass("active");
			// 			if(progress_8 > 0.001 && progress_8 < 0.10){
			// 				mySwiper_1.slideTo(3, 500, false);
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_1").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-1.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_2").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-2.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_3").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-3.webp');
			// 			}else if(progress_8 > 0.10 && progress_8 < 0.33){
			// 				mySwiper_1.slideTo(3, 500, false);
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_1").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-1-sk.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_2").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-2.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_3").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-3.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .div_back").removeClass("active");
			// 				$("#ut3 .ut3_8 .swiper-slide.swiper-slide-active .div_back").addClass("active");
			// 			}else if(progress_8 > 0.33 && progress_8 < 0.43){
			// 				mySwiper_1.slideTo(4, 500, false);
			// 			}else if(progress_8 > 0.43&& progress_8 < 0.68){
			// 				mySwiper_1.slideTo(4, 500, false);
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_1").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-1.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_2").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-2-sk.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_3").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-3.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .div_back").removeClass("active");
			// 				$("#ut3 .ut3_8 .swiper-slide.swiper-slide-active .div_back").addClass("active");
			// 			}else if(progress_8 > 0.68 && progress_8 < 0.78){
			// 				mySwiper_1.slideTo(5, 500, false);
			// 			}else if(progress_8 > 0.78 && progress_8 < 1){
			// 				mySwiper_1.slideTo(5, 500, false);
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_1").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-1.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_2").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-2.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_3").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-3-sk.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .div_back").removeClass("active");
			// 				$("#ut3 .ut3_8 .swiper-slide.swiper-slide-active .div_back").addClass("active");
			// 			}else if(progress_8 == 1){
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_1").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-1.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_2").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-2.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .img_src_3").attr('src', 'https://download.ugee.com/static/product/ut3-2/8-3-sk.webp');
			// 				$("#ut3 .ut3_8 .swiper-slide .div_back").removeClass("active");
			// 				$("#ut3 .ut3_8 .swiper-slide.swiper-slide-active .div_back").addClass("active");
			// 			}
			// 		}
			// 	});	
			
			//弟13屏动画
			// var ut3_back_13 = $("#ut3 .ut3_13 .bigbox .back");
			// var div_abo_13 = $("#ut3 .ut3_13 .bigbox .div_abo");
			// var ut2_13_sticky = $("#ut3 .ut3_13 .ut3_13_sticky");
			// var s_13 = gsap.timeline();
		 //        s_13.to(ut3_back_13, 1, {
			// 	    opacity: "0",
			// 	}).to(ut3_back_13, 3, {
			// 		opacity: "0.6",
			// 	});
				
			// 	s_13.to(div_abo_13, 1, {
					
			// 	}).to(div_abo_13, 4, {
					
			// 	});
			// 	ScrollTrigger.create({
			// 		animation: s_13,
			// 		trigger: ut2_13_sticky,
			// 		scrub: !0,
			// 		start: "top 100%",
			// 		end: "bottom 110%",
			// 		onUpdate: function(e) {
			// 			var much_13 = e.progress;
			// 				if(much_13 > 0.4){
			// 					$("#ut3 .ut3_13 .bigbox .div_abo").fadeIn();
			// 				}else{
			// 					$("#ut3 .ut3_13 .bigbox .div_abo").fadeOut();
			// 				}
			// 		}
			// 	});	
			
			//弟17屏动画
			// var ut3_back_17 = $("#ut3 .ut3_17 .bigbox .back");
			// var div_abo_17 = $("#ut3 .ut3_17 .bigbox .div_abo");
			// var ut2_17_sticky = $("#ut3 .ut3_17 .ut3_17_sticky");
			// var s_17 = gsap.timeline();
		 //        s_17.to(ut3_back_17, 1, {
			// 	    opacity: "0",
			// 	}).to(ut3_back_17, 3, {
			// 		opacity: "0.6",
			// 	});
			// 	s_17.to(div_abo_17, 1, {
					
			// 	}).to(div_abo_17, 4, {
					
			// 	});
			// 	ScrollTrigger.create({
			// 		animation: s_17,
			// 		trigger: ut2_17_sticky,
			// 		scrub: !0,
			// 		start: "top 100%",
			// 		end: "bottom 110%",
			// 		onUpdate: function(e) {
			// 			var much_17 = e.progress;
			// 				if(much_17 > 0.4){
			// 					$("#ut3 .ut3_17 .bigbox .div_abo").fadeIn();
			// 				}else{
			// 					$("#ut3 .ut3_17 .bigbox .div_abo").fadeOut();
			// 				}
			// 		}
			// 	});	
			
			//弟18屏动画
			var ut3_18 = $("#ut3 .ut3_18 .bigbox");
			var s_18 = gsap.timeline();
				ScrollTrigger.create({
					animation: s_18,
					trigger: ut3_18,
					scrub: !0,
					start: "top 25%",
					end: "bottom 100%",
					onUpdate: function(e) {
						if(e.progress == 1){
							$("#ut3 .ut3_18 .bigbox .box_ul.box_ul_1 .box_li_2 .line_box .line1").addClass("active");
							$("#ut3 .ut3_18 .bigbox .box_ul.box_ul_2 .box_li_2 .line_box .line1").addClass("active");
						}
					}
				});
				
			
		}
	}
	
